module.exports = __webpack_public_path__ + "img/vision_02.53d8d0b0.webp";